import React from "react";
import { Modal} from "antd";
import { URL_POND, URL_TANK, URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString, dateToHumanString } from "../../frameworks/Util";
import _ from "lodash";

export default function LotSkimHistoryModal(props) {
  const { open, onClose, target } = props;
  const tableRef = React.useRef();
  const columns = [
    {
      title: 'แทงก์',
      dataIndex: 'tank_name',
      key: 'tank_name',      
    },
    {
      title: 'บ่อ',
      dataIndex: 'pond_name',
      key: 'pond_name',      
    },
    {
      title: 'เริ่มเดินเครื่อง',
      dataIndex: 'start',
      key: 'start',
      render : (value) => dateToHumanString(value)
    },
    {
      title: 'หยุดเดินเครื่อง',
      dataIndex: 'end',
      key: 'end',
      render : (value) => dateToHumanString(value)
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  return(
    <Modal
      title={<center>ประวัติเดินเครื่อง</center>}
      open={open}
      onCancel={onClose}
      width={600}
      destroyOnClose
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      {target && <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TANK.TANK_POND_TRANSACTION}
        hidePagination={true}
        params={{skim_transaction : target.id}}
      />}
    </Modal>
  )
}